import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { secondaryModalState } from "../../../state-observables/modal/ModalState";
import styles from "./styles.module.css";


type Props = {

};


export default function ConnectingLoadingSpinnerModal({ }: Props) {
  const { t } = useTranslation();
  useEffect(() => {
    // close modal after 3 minutes assuming no connection will take that long
    setTimeout(() => {
      secondaryModalState.closeModal();
    }, 180000); 
  }, []);

  return (
    <div className={styles.container}>
      {t("connection.connecting_loading")}
    </div>
  );
}
